// custom typefaces
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/plugins/line-numbers/prism-line-numbers.css'
import './src/styles/reset.scss'
import './src/styles/styles.scss'
import './src/styles/font-awesome.css'
